module.exports = __webpack_public_path__ + "img/EXITO.560f7b1c.png";